






































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { IProposal } from "@/types/proposal";
import { IPost, IPostCreateRequest } from "@/types/post";
import PostForm from "@/components/sale/forms/PostForm.vue";
import { ISelectItem } from "@/types";
import { PostCreateRequest } from "@/models/post";
import { IProposalStatusListRequest } from "@/types/proposalStatus";

@Component({
  components: {
    PostForm,
  },
})
export default class extends Vue {
  @Action("proposal/salesGet")
  public get!: (id: number) => Promise<void>;

  @Getter("proposal/single")
  public proposal!: IProposal;

  @Action("proposal/salesDelete")
  public delete!: (id: number) => Promise<boolean>;

  @Mutation("proposal/clear")
  public clear!: () => void;

  @Action("post/salesProposalPostCreate")
  public create!: (data: {
    postable_id: number;
    params: IPostCreateRequest;
  }) => Promise<boolean>;

  @Getter("post/single")
  public newPost!: IPost;

  @Action("proposalStatus/getList")
  public getStatuses!: (params: IProposalStatusListRequest) => Promise<void>;

  @Getter("proposalStatus/selectItem")
  public proposalStatuses!: ISelectItem[];

  public proposal_id = 0;
  public member_id = 0;
  public current_status_id = 0;
  public proposalStatusId = 0;
  public dialog = false;
  public offerdialog = false;

  public params: IPostCreateRequest = new PostCreateRequest();

  public async created() {
    this.member_id = Number(this.$route.params.member_id);
    this.proposal_id = Number(this.$route.params.proposal_id);

    this.clear();
    await Promise.all([
      this.get(this.proposal_id),
      this.getStatuses({ per_page: 0 }),
    ]);
    this.params.status_id = this.proposal.proposal_status_id;
    this.current_status_id = this.proposal.proposal_status_id;
  }

  public async destroy() {
    const result = await this.delete(this.proposal_id);
    if (result) {
      this.$router.go(-1);
    }
  }

  public get posts(): IPost[] {
    return this.proposal.posts;
  }

  public get editPage() {
    if (this.member_id) {
      return {
        name: "SalesMemberProposalEdit",
        params: {
          proposal_id: this.proposal_id,
          member_id: this.member_id,
        },
      };
    }
    return {
      name: "SalesProposalEdit",
      params: { proposal_id: this.proposal_id },
    };
  }

  public async postCreated() {
    if (this.proposal_id) {
      const result = await this.create({
        postable_id: this.proposal_id,
        params: this.params,
      });
      if (result) {
        this.params.contents = "";
        await this.get(this.proposal_id);
      }
    }

    //承諾に変更
    if (
      this.params.status_id === 5 &&
      this.current_status_id != this.params.status_id &&
      this.proposal.members.length === 1
    ) {
      this.member_id = this.proposal.members[0].id;
      this.offerdialog = true;
    }
  }
}
